<template>
  <div class="gestioneutenti">
    <b-row>
      <b-col class="mb-3">
        Utenti attivi nelle ultime 4 ore: 
        <b>{{numLoggati}}</b>
      </b-col>
    </b-row>
    <b-row>
      <b-col>Legenda:</b-col>
      <b-col class="abbonato">Utente abbonato</b-col>
      <b-col class="scaduto">Utente scaduto</b-col>
      <b-col class="disabilitato">Utente non attivo</b-col>
      <b-col class="prova">Utente in prova</b-col>
      <b-col class="fattura">Fattura da emettere</b-col>
    </b-row>
    <b-row>
      <b-col class="pt-3 text-right">
        Tipi di utenti da mostrare:
      </b-col>
      <b-col>
        <b-form-select @change="showOnly" v-model="tipoAvvocati" size="sm" class="mt-3">
          <option :value="``">Qualsiasi</option>
          <option :value="`abbonato`">Utente abbonato</option>
          <option :value="`scaduto`">Utente scaduto</option>
          <option :value="`disabilitato`">Utente non attivo</option>
          <option :value="`prova`">Utente in prova</option>
          <option :value="`fattura`">Fattura da emettere</option>
        </b-form-select>
      </b-col>
    </b-row>

    <BootstrapTable
      id="table"
      :columns="columns"
      :data="data"
      :options="options"
    />
  </div>
</template>

<script>
import services from '../../services/service.js'

export default {
  name: 'gestioneutenti',
  data () {
    return {
      columns: [
        {
          title: 'Nome',
          sortable: true,
          cellStyle: this.cellStyle,
          formatter: function(value, row, index, field) {
            let href = '/profilo/' + row.codFisc;
            return `<a href="${href}" target="_blank_">${row.nome}</a>`;
          }
        },
        {
          title: 'Cognome',
          field: 'cognome',
          sortable: true,
          cellStyle: this.cellStyle
        },
        {
          title: 'Codice Fiscale',
          field: 'codFisc',
          sortable: true,
          cellStyle: this.cellStyle
        },
        {
          title: 'Abilitato',
          field: 'abilitato',
          cellStyle: this.cellStyle
        },
        {
          title: 'Data scadenza',
          field: 'dataScadenza',
          sortable: true,
          cellStyle: this.cellStyle
        },
        {
          title: 'Ha profilo',
          field: 'haProfilo',
          sortable: true,
          cellStyle: this.cellStyle
        },
        {
          title: 'Ha commentato',
          field: 'haCommentato',
          sortable: true,
          cellStyle: this.cellStyle
        },
        {
          title: 'Ha login',
          field: 'haLogin',
          sortable: true,
          cellStyle: this.cellStyle
        },
        {
          title: '',
          formatter: function(value, row, index, field) {
            let href = '/admin/utenti/' + row.codFisc;
            return `<a type="button" class="btn btn-primary" href="${href}">Modifica</a>`;
          }
        },
        {
          title: '',
          formatter: function(value, row, index, field) {
            let href = 'https://www.urbanisticaitaliana.it/fatturaListaCliente.php?username=' + row.codFisc;
            return `<a type="button" class="btn btn-primary" target="_blank_" href="${href}">Fatture emesse</a>`;
          }
        },
        {
          title: '',
          formatter: function(value, row, index, field) {
            if(row.stato != 'fattura')
              return '';
            return `
              <button class="btn btn-success btn-fattura">Emetti fattura</button>
              <form id="fattura-${row.codFisc}" action="https://www.urbanisticaitaliana.it/fatturaPrestampa.php" method="post">
                <input type="radio" style="display:none" checked="checked" name="tipoAbbonamento" value="GiustUp.it">
                <input type="hidden" name="username" value="${row.codFisc}">
                <input type="hidden" name="denominazione" value="${row.denominazione}">
                <input type="hidden" name="indirizzo" value="${row.indirizzo}">
                <input type="hidden" name="civico" value="">
                <input type="hidden" name="citta" value="${row.citta}">
                <input type="hidden" name="cap" value="${row.cap}">
                <input type="hidden" name="provincia" value="${row.provincia}">
                <input type="hidden" name="emailCliente" value="${row.emailPagante}">
                <input type="hidden" name="codiceFiscale" value="${row.codFiscPagante}">
                <input type="hidden" name="partitaIva" value="${row.piva}">
                <input type="hidden" name="codiceUfficio" value="${row.codiceUfficio}">
                <input type="hidden" name="rivistaNome" value="www.giustup.it">
                <input type="hidden" name="scadenzaAbbonamento" value="${row.dataScadenza}">
                <input type="hidden" name="username" value="CNS">
                <input type="hidden" name="password" value="CNS">
                <input type="hidden" name="split" value="0">
                <input type="hidden" name="sender" value="admin@giustup.it">
                <input type="hidden" name="totale" value="${row.corrispettivo}">
                <input type="hidden" name="pec" value="${row.pec}">
              </form>
            `;
          },
          events: {
            'click .btn-fattura': function(e, value, row, index) {
              let url = 'utente/admin/' + row.codFisc + '/fattura';
              services.execute('post', url, undefined, true).then((resp) => {
                if(resp.status === 200){
                  $("#fattura-" + row.codFisc).submit();
                }
                else{
                  alert("Errore emissione fattura!")
                }
              });
            }
          }
        }
      ],
      data: [],
      options: {
        search: true,
        pagination: true
      },
      tipoAvvocati: '',
      numLoggati: ''
    }
  },
  methods: {
    async getData() {
      this.data = await services.execute('get', 'utente/admin');
      // console.log(data)
    },
    cellStyle(value, row, index, field) {
      return {
        classes: row.stato
      };
    },
    showOnly(){
      let param = this.tipoAvvocati;
      let filter = {
        stato: param
      };
      if(param === '')
        filter = {};
      $('#table').bootstrapTable('filterBy', filter);
    },
    async getLoggati() {
      this.numLoggati = await services.execute('get', 'utente/admin/loggati');
    }
  },
  async created() {
    await this.getData();
    this.getLoggati();

    this.$parent._data.loaded = true;
  }
}
</script>

<style>
.fattura {
  background-color: aquamarine;
}
.disabilitato {
  background-color: burlywood;
}
.scaduto {
  background-color: gray;
}
.prova {
  background-color: yellow;
}
.abbonato {
  background-color: darkseagreen;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/GestioneUtenti.vue